export * from './lista-plataformas';